module.exports = __webpack_public_path__ + "img/facebook.03146137.svg";